export default {"src":"/_next/static/media/indianPlastics.5a4febf6.svg","height":159,"width":130};